"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBillingTabLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// styles
//
const StyledIcon_1 = require("./StyledIcon");
//
// properties
//
const config_1 = require("../../../../assets/styles/config");
exports.StyledBillingTabLink = styled_components_1.default.a `
  border-bottom: 1px solid ${config_1.colors.huron};
  color: ${config_1.colors.grayText};
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin-right: 20px;
  padding: 25px 0;

  &:hover,
  &:focus {
    color: ${config_1.colors.blurple};
    cursor: pointer;

    ${StyledIcon_1.StyledIcon} {
      color: ${config_1.colors.blurple};
      cursor: pointer;
    }
  }
`;
